import * as React from 'react'

import { Button, Link, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import DeprecatedInputText from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import asyncAction from 'modules/core/lib/asyncAction'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
}

class IRPFForm extends Form {
  constructor(values: {}) {
    super(values, {
      country_metadata: {
        irpf_in_cents: 'cents',
      },
    })
  }
}

const Irpf = (props: Props) => {
  const { employee } = props

  const [form, setForm] = React.useState(
    new IRPFForm({
      country_metadata: employee.attributes.country_metadata,
    })
  )
  React.useEffect(() => {
    setForm(
      new IRPFForm({
        country_metadata: employee.attributes.country_metadata,
      })
    )
  }, [employee.attributes.id]) // eslint-disable-line

  const errorsWithMetadata = (errors: any) => {
    if (!errors || !errors.irpf_in_cents) return errors

    return {
      ...errors,
      country_metadata: {
        irpf_in_cents: errors.irpf_in_cents,
      },
    }
  }

  const onSubmit = async () => {
    form.resetErrors()

    const { success, value } = await asyncAction(() => form.save(employee))
    form.cleanAll()

    if (!success) {
      form.setErrors(errorsWithMetadata(value))
    }
  }

  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        description={i18n.tCurrent('hiring.irpf_description', employeeUser(employee).isCurrent())}
        illustration="control-navigation-adjust-sound"
        title={i18n.t('common.irpf')}
      />
      <FormComponent>
        <FormRow>
          <DeprecatedInputText
            label={i18n.t('employee_form.irpf.label')}
            field={form.get('country_metadata.irpf_in_cents')}
          />
        </FormRow>
        {form.isDirty && (
          <>
            <FormRow>
              <Text.Normal>{i18n.t('employee_form.irpf.information')}</Text.Normal>
            </FormRow>
            <FormRow>
              <Link.Href target="_blank" href={buildUrl('/solicitud_irpf_superior.pdf')}>
                {i18n.t('employee_form.irpf.download_irpf_document')}
              </Link.Href>
            </FormRow>
            <FormRow footer>
              <Button onClick={onSubmit}>{i18n.t('common.submit')}</Button>
            </FormRow>
          </>
        )}
      </FormComponent>
    </PanesPadForm>
  )
}

export default observer(Irpf)
